import { render, staticRenderFns } from "./ETRView.vue?vue&type=template&id=e6e9291a&"
import script from "./ETRView.vue?vue&type=script&lang=js&"
export * from "./ETRView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ETRView.vue?vue&type=custom&index=0&blockType=span&v-if=items%5B0%5D.items.length%20%3E%201&class=text-3x%20strong"
if (typeof block0 === 'function') block0(component)
import block1 from "./ETRView.vue?vue&type=custom&index=1&blockType=span&v-else=true&class=text-3x%20strong"
if (typeof block1 === 'function') block1(component)

export default component.exports